export default __webpack_public_path__ + "static/network-3@2x-4da7e129d6b6ed0f9b21f293f4331e66.png";